// extracted by mini-css-extract-plugin
export default {"header-text":"modalAddGame_header-text__u2Yg4"};